import { ScrollSync, ScrollSyncPane } from "react-scroll-sync";

import * as theme from "./StickyHeaderOverflowTable.css";
import { Table } from "./Table";

// Enables the table head (and the toolbar above it) to be sticky when
// scrolling, while properly handling horizontal table overflow

// Only works with fixed layout - otherwise can't sync col widths of detached thead

// Head, body and scrollbar are ScrollSync panes: scrolling one scrolls the rest
interface StickyHeaderOverflowTableProps {
    headComponent: React.ReactNode;
    bodyComponent: React.ReactNode;
    /**
     * Visible columns' total width (`table.getTotalSize()`), sizing the sticky
     * scrollbar and flooring both tables at the columns' declared sizes.
     */
    contentWidth: number;
    /** Rendered above the head and pinned together with it. */
    toolbarComponent?: React.ReactNode;
    tableRef?: React.RefObject<HTMLDivElement | null>;
}
export function StickyHeaderOverflowTable({
    headComponent,
    bodyComponent,
    contentWidth,
    toolbarComponent,
    tableRef,
}: StickyHeaderOverflowTableProps) {
    return (
        <ScrollSync>
            <div ref={tableRef}>
                <div className={theme.stickyTop}>
                    {toolbarComponent}
                    <ScrollSyncPane>
                        <div className={theme.headWrapper}>
                            <Table layoutFixed minWidth={contentWidth}>
                                {headComponent}
                            </Table>
                        </div>
                    </ScrollSyncPane>
                </div>
                <ScrollSyncPane>
                    <div className={theme.bodyWrapper}>
                        <Table layoutFixed minWidth={contentWidth}>
                            {bodyComponent}
                        </Table>
                    </div>
                </ScrollSyncPane>
                <ScrollSyncPane>
                    <div className={theme.stickyScrollbarWrapper}>
                        <div
                            className={theme.stickyScrollbarSpacer}
                            style={{ width: contentWidth }}
                        />
                    </div>
                </ScrollSyncPane>
            </div>
        </ScrollSync>
    );
}
